module.exports = function() {
  return new Worker(__webpack_public_path__ + "2247b3144796ff142c2b.worker.js");
};